<template>
  <button @click="addToWishList" class="tooltip wishlist" aria-label="dodaj u listu želja"
          data-tooltip="Dodaj u listu želja">

    <heart-icon></heart-icon>
  </button>
</template>

<script>
  export default {
    name: "AddToWishlist",

    props: ['productCode'],

    methods: {
      addToWishList() {
        console.log(this.productCode);

        axios.post('/dodaj-u-listu-zelja', {productCode: this.productCode})
            .then(response => {
              this.$toasted.global.toastSuccess({ message: response.data.message });


            })
            .catch(error => {
              if (error.response.data.message === 'Unauthenticated.') {
                this.$toasted.global.toastError({message: 'Morate biti ulogovani da biste dodali proizvod u listu želja.'});
              } else {
                this.$toasted.global.toastError({message: error.response.data.message});
              }
            })
      }

    }
  }
</script>
